<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dNX6Eh/tc-custom/9781504047357.jpg?1726519168454" alt="This image is the cover for the book Monday or Tuesday"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Monday or Tuesday
      </h1>
      <p class="bookDescription body article font2">
        <b>A stylistically innovative volume of short stories from the groundbreaking author of <i>Mrs. Dalloway</i>, <i>To the Lighthouse</i>, and <i>Orlando</i>.</b><br/>  <br/> First presented as one volume in 1921, <i>Monday or Tuesday</i> was the only collection of stories Virginia Woolf published in her lifetime. Written in her experimental, stream-of-consciousness style, these eight unconventional stories eschew traditional plot and character development in favor of interior thoughts, emotions, memories, and associations.<br/>  <br/> From a heron’s in-flight perceptions in “Monday or Tuesday” to a ghost couple searching for treasure in “A Haunted House,” from a meditation on color as a catalyst for imagination and emotional connections in “Blue and Green” to the invented stories of a narrator on a train observing a fellow passenger in “An Unwritten Novel,” Woolf’s poetic explorations take readers in directions previously unexamined, revealing an intensity of feeling and depth of insight that would continue to characterize her later work.<br/>  <br/> Michael Cunningham, author of the Pulitzer Prize–winning novel <i>The Hours</i>, has said of Woolf: “She was doing with language something like what Jimi Hendrix does with a guitar.” Taken together, these lyrical and evocative stories create a rich mosaic of the artist’s radically unique sensibility.<br/>  <br/> Monday or Tuesday <i>includes</i><i>“A Haunted House,” “A Society,” “Monday or Tuesday,”</i><br/><i>“An Unwritten Novel,” “The String Quartet,” “Blue and Green,” “Kew Gardens,” and “The Mark on the Wall.”</i><br/>  <br/><i>This ebook has been professionally proofread to ensure accuracy and readability on all devices.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Virginia Woolf
      </h2>
      
      <p class="authorDescription body article"> Virginia Woolf (1882&ndash;1941), an English modernist, has been heralded as one of the greatest female writers of all time. In 1915, she published her first novel, <I>The Voyage Out</I>, which became known for its peculiar narrative perspectives and free-association prose. She followed this up with several famous novels such as <I>Mrs. Dalloway</I> and<I> Jacob&rsquo;s Room</I>, as well as the feminist essay <I>A Room of One&rsquo;s Own</I>. Woolf suffered from depression and committed suicide in 1941. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?97bcdaf4